export default "__VITE_ASSET__46KH3ej0__"